import React, { useEffect } from 'react';
import { useTheme } from '@chakra-ui/react';
import Cal, { getCalApi } from '@calcom/embed-react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CalcomEmbed = _ref => {
  let {
    calLink
  } = _ref;
  const theme = useTheme();
  useEffect(() => {
    (async function () {
      const cal = await getCalApi();
      cal('ui', {
        'theme': theme.initialColorMode,
        'styles': {
          'branding': {
            'brandColor': theme.colors.brand['500']
          }
        },
        'hideEventTypeDetails': false,
        'layout': 'month_view'
      });
    })();
  }, []);
  return ___EmotionJSX(Cal, {
    calLink: calLink,
    style: {
      width: '100%',
      height: '100%',
      overflow: 'scroll'
    },
    config: {
      layout: 'month_view'
    }
  });
};
export default CalcomEmbed;